export class Breadcrumb {
    to;
    text;
    constructor(text, to) {
        this.to = to;
        this.text = text;
    }
}
